var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHashpackWalletLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 6,
    fill: "#272727"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_925_2334)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 19.8182C38 25.2406 33.7467 29.6364 28.5 29.6364C23.2533 29.6364 19 25.2406 19 19.8182C19 17.7095 20.6541 16 22.6944 16C24.7348 16 26.3889 17.7095 26.3889 19.8182V27.1383C27.7579 27.5594 29.2421 27.5594 30.6111 27.1383V19.8182C30.6111 17.7095 32.2652 16 34.3056 16C36.3459 16 38 17.7095 38 19.8182ZM22.6944 18.1818C23.5689 18.1818 24.2778 18.9144 24.2778 19.8182V26.0858C22.3635 24.7059 21.1111 22.4132 21.1111 19.8182C21.1111 18.9144 21.82 18.1818 22.6944 18.1818ZM32.7222 19.8182V26.0858C34.6365 24.7059 35.8889 22.4132 35.8889 19.8182C35.8889 18.9144 35.18 18.1818 34.3056 18.1818C33.4311 18.1818 32.7222 18.9144 32.7222 19.8182Z",
    fill: "#7A7AB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7222 36.1818V31.0001C30.0312 32.0864 26.9666 32.0856 24.2778 31.0001V36.1818C24.2778 37.0856 23.5689 37.8182 22.6944 37.8182C21.82 37.8182 21.1111 37.0856 21.1111 36.1818V29.0753C20.3101 28.3916 19.5993 27.599 19 26.7195V36.1818C19 38.2906 20.6541 40 22.6944 40C24.7348 40 26.3889 38.2906 26.3889 36.1818V33.8332C27.785 34.056 29.215 34.056 30.6111 33.8332V36.1818C30.6111 38.2906 32.2652 40 34.3056 40C36.3459 40 38 38.2906 38 36.1818V26.7195C37.4007 27.599 36.6899 28.3916 35.8889 29.0753V36.1818C35.8889 37.0856 35.18 37.8182 34.3056 37.8182C33.4311 37.8182 32.7222 37.0856 32.7222 36.1818Z",
    fill: "#7A7AB8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_925_2334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 24,
    fill: "white",
    transform: "translate(19 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashpackWalletLogo);
export default __webpack_public_path__ + "static/media/hashpack-wallet-logo.3bcc190c8053ed44d494d8c51d10a76f.svg";
export { ForwardRef as ReactComponent };